"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getDivDimensions_1 = __importDefault(require("../getDivDimensions"));
function getDivWidth(str, addStyles) {
    return getDivDimensions_1.default(str, addStyles)[0];
}
exports.default = getDivWidth;
//# sourceMappingURL=index.js.map